import { Area } from 'react-easy-crop/types';

export const getCroppedImg = (
  imageSrc: string,
  pixelCrop: Area,
  type: 'base64' | 'blob' = 'base64'
): Promise<string | Blob> => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = imageSrc;
    image.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = pixelCrop.width;
      canvas.height = pixelCrop.height;
      const ctx = canvas.getContext('2d');

      if (!ctx) return reject("Canvas context not found");

      ctx.drawImage(
        image,
        pixelCrop.x,
        pixelCrop.y,
        pixelCrop.width,
        pixelCrop.height,
        0,
        0,
        pixelCrop.width,
        pixelCrop.height
      );

      if (type === 'blob') {
        canvas.toBlob((blob) => {
          if (!blob) return reject("Failed to convert to Blob");
          resolve(blob);
        }, 'image/jpeg');
      } else {
        const base64 = canvas.toDataURL('image/jpeg');
        resolve(base64);
      }
    };
    image.onerror = () => reject("Failed to load image");
  });
};
